import React, { useState } from "react";
import { VoipDevFaqs } from "../../components/faqData.js";

import Contact from "../../components/Contact.js";
import GetInTouch from "../../components/GetInTouch.js";
import AyanshtechAdvantage from "../../components/AyanshtechAdvantage.js";
import { Helmet } from "react-helmet-async";

const VoIPDevelopers = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };
  const scrollToContact = () => {
    const contactSection = document.getElementById("contact-section");
    contactSection.scrollIntoView({ behavior: "smooth" });
  };

  
  return (<>
    <Helmet>
      <meta name="description" content="Hire expert VoIP developers in India to build reliable, scalable, and feature-rich communication solutions. Get custom VoIP development for your business success." />
      <meta name="copyright" content="codeglim" />
      <meta property="og:title" content="Hire Expert VoIP Developers in India | Ayanshtech Solutions" />
      <meta property="og:site_name" content="Ayanshtech Solutions" />
      <meta property="og:url" content="https://ayanshtechnology.com/hire-voip-developers" />
      <meta property="og:description" content="Hire expert VoIP developers in India to build reliable, scalable, and feature-rich communication solutions. Get custom VoIP development for your business success." />
      <meta property="og:type" content="website" />
      <meta property="og:image" content="https://ayanshtechnology.com/assets/logo.png" />

      <meta name="twitter:card" content="summary" />
      <meta name="twitter:site" content="@Ayanshtech Solutions" />
      <meta name="twitter:title" content="Hire Expert VoIP Developers in India | Ayanshtech Solutions" />
      <meta name="twitter:description" content="Hire expert VoIP developers in India to build reliable, scalable, and feature-rich communication solutions. Get custom VoIP development for your business success." />
      <meta name="twitter:image" content="https://ayanshtechnology.com/assets/logo.png" />

      <link rel="canonical" href="https://ayanshtechnology.com/hire-voip-developers" />
      <title>Hire Expert VoIP Developers in India | Ayanshtech Solutions</title>
    </Helmet>
    <div className="min-h-screen flex flex-col items-center justify-center p-6">
      <div className=" p-4 w-full">
        <div className="flex flex-col lg:flex-row items-center lg:space-x-16 mt-10">
          <div className="lg:w-3/4  lg:text-left ">
            <h1 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
              Hire Expert VoIP Developers
            </h1>
            <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 leading-relaxed mb-3">
              VoIP development is essential for businesses aiming to enhance
              communication systems with cost-effective, scalable, and
              feature-rich solutions. At Ayanshtech, we provide skilled VoIP
              developers proficient in technologies like SIP, Kamailio,
              FreeSWITCH, and Asterisk. Our team ensures your communication
              platform is reliable, secure, and optimized for seamless voice and
              video interactions.
              <br />
              <br />
              Whether you need a custom VoIP application, integration with
              existing systems, or advanced features like call analytics and
              conferencing, our VoIP developers have the expertise to meet your
              requirements. Hire VoIP developers from Ayanshtech to create
              robust, scalable, and future-ready communication solutions
              tailored to your business needs.
            </p>
            <p className="  text-gray-600 sm:text-lg md:text-xl lg:text-xl">
              Starting from just <span className="font-bold">US $16/hour</span>
            </p>
            <button
              onClick={scrollToContact}
              className="bg-green-600 text-white hover:bg-yellow-500 hover:text-green-700 hover:border hover:border-yellow-500 font-semibold p-3 rounded-full mt-6"
            >
              Hire a VoIP Developer
            </button>
          </div>
          <div className="flex justify-center mt-5 mb10 lg:mb-0">
            <img
              src="\assets\images\homeImages\viopDev.png"
              alt="VoIP Development"
              className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
            />
          </div>
        </div>
      </div>

      <div className="text-center mb-5 mt-10">
        <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
          Key Skills of Our VoIP Developers
        </h2>
        <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
          When you hire VoIP professionals from our team, you gain access to
          their deep expertise in voice communication technologies, ensuring
          exceptional performance and scalability for your telecommunication
          projects.
        </p>
      </div>

      <div className=" p-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon1.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">VoIP system design and deployment</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon2.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">SIP trunk configuration</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon3.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">Integration with CRM and ERP systems</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon4.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">Custom IVR development</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon5.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">Call routing and quality optimization</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon6.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">Secure VoIP implementation</p>
          </div>
        </div>
      </div>

      <div className="text-center mt-10  ">
        <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
          Experienced VoIP Developers
        </h2>
        <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
          Ayanshtech offers customizable hiring models to align with your
          specific project needs, whether for short-term assignments or
          long-term commitments.
        </p>
      </div>

      <div className=" ">
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div className="w-full md:w-1/3 p-4">
            <img
              src="\assets\images\homeImages\VoipSol.png"
              alt="Graph on a laptop screen"
              className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
            />
          </div>

          <div className="md:w-1/2 lg:w-3/4 p-4 grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon7.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Partner with skilled VoIP developers from Ayanshtech,
                  proficient in delivering top-notch solutions.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon8.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Evaluate and interview pre-screened experts to find the ideal
                  match for your team.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon9.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Receive personalized guidance from our consultants to select
                  the right VoIP specialist for your needs.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon10.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Flexible hiring models ensure a perfect fit for both your
                  budget and project requirements.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AyanshtechAdvantage />

      {/* <div className="max-w-3xl mx-auto p-4 mt-10  w-full ">
        <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-center mb-8">
          FAQs
        </h2>
        {VoipDevFaqs.map((faq, index) => (
          <div key={index} className="border-b-2 border-blue-300">
            <button
              onClick={() => toggleFAQ(index)}
              className={`w-full text-left py-4 flex justify-between items-center focus:outline-none ${
                activeIndex === index
                  ? "bg-blue-600 text-white px-5 rounded-2xl"
                  : ""
              }`}
            >
              <span className="text-lg">{faq.question}</span>
              <span className="text-2xl">
                {activeIndex === index ? "-" : "+"}
              </span>
            </button>
            {activeIndex === index && (
              <div className="p-4 text-gray-700">{faq.answer}</div>
            )}
          </div>
        ))}
      </div>

      <div id="contact-section">
        {" "}
        <Contact />
      </div> */}

      <div className="h-[30px] md:h-[60px] lg:h-[80px]"></div>
      <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-center mb-16">
        FAQs
      </h2>
      <div className="flex flex-col md:flex-row justify-around mb-5  md:mb-4 lg:mb-5 item-center ">

        <div className="w-full  md:w-1/2 lg:w-[616px]  mb-8 md:mb-4 lg:mb-0">
          {/* <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-center mb-8">
                        FAQs
                    </h2> */}
          {VoipDevFaqs.map((faq, index) => (
            <div key={index} className="border-b-2 border-blue-300">
              <button
                onClick={() => toggleFAQ(index)}
                className={` w-full text-left py-4 flex justify-between items-center focus:outline-none ${activeIndex === index
                  ? "bg-blue-600 text-white px-5 rounded-2xl"
                  : ""
                  }`}
              >
                <span className="text-lg">{faq.question}</span>
                <span className="text-2xl">
                  {activeIndex === index ? "-" : "+"}
                </span>
              </button>
              {activeIndex === index && (
                <div className="p-4 text-gray-700">{faq.answer}</div>
              )}
            </div>
          ))}
        </div>

        <div id="contact-section" className="w-full md:w-1/2 lg:w-1/2">
          {" "}
          <Contact />
        </div>


      </div>

      <GetInTouch />
    </div>
  </>);
};

export default VoIPDevelopers;
